import React from 'react';
import {Form, Header, Input} from 'semantic-ui-react'
import {
    MFAContainer,
} from "../../styled";
import {MFA_TYPE} from "../../constants";
import {CustomContainer, CustomDivider, CustomGrid} from "../../../components/custom-common";


const MethodItem = ({
  title,
  disabled,
  description,
}) => {
    return (
      <CustomContainer className={`mfaMethodContainer ${disabled && "shortMode"}`}>
          <div>
              <p className={`mfaMethodTitle ${disabled ? 'mfaMethodTitleDisabled' : ''}`}>{title}</p>
              {!disabled && <p className={"small neutral900Text"}>
                  {description}
              </p>}

              </div>
              {disabled && <span className={'mfaMethodComingSoon'}>Coming soon</span>}

      </CustomContainer>
    )
}

const MethodSelector = ({
  methodType,
  selectMethodHandler,
  isEmailConfigured,
  isTotpConfigured,
  isSmsConfigured
}) => {

    const wrapSelectMethodHandler = (disable, type) => {
        if(disable) return;
        selectMethodHandler(type)
    }

    return (
        <>
        <MFAContainer className="sectionWrapper" maxWidth={"530px"}>
            <CustomGrid centered>
                <CustomGrid.Row>
                    <CustomGrid.Column>
                        <Header as="h2" className={'noVerticalMargin'}>Select your method</Header>
                        <CustomDivider smaller hidden/>
                        <p className={'neutral700Text noVerticalMargin'}>Choose one of the two-factor authentication methods below—</p>
                        <CustomDivider smaller hidden/>
                    </CustomGrid.Column>
                </CustomGrid.Row>
                <CustomGrid.Row>
                        <CustomGrid.Column>
                            <Form>
                                <Form.Group grouped>
                                    <CustomGrid padded={false}>
                                        <CustomGrid.Row fitted={'vertically'}>
                                            <CustomGrid.Column>
                                                <Form.Field
                                                  inline
                                                  className={'mfaMethodField'}
                                                  onClick={() => wrapSelectMethodHandler(isTotpConfigured, MFA_TYPE.TOTP)}
                                                >
                                                    <Input
                                                        control='input'
                                                        type='radio'
                                                        name='method'
                                                        id="authenticator"
                                                        checked={(methodType === MFA_TYPE.TOTP && !isTotpConfigured)}
                                                        disabled={isTotpConfigured}
                                                    />
                                                    <MethodItem
                                                        title={"Authenticator App"}
                                                        type={MFA_TYPE.TOTP}
                                                        isItConfigured={isTotpConfigured}
                                                        disabled={isTotpConfigured}
                                                        description="Use an authenticator app to generate authentication codes."
                                                    />
                                                </Form.Field>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row fitted={'vertically'}>
                                            <CustomGrid.Column>
                                                <div className={'mfaMethodsOrDivider'}><b>OR</b></div>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row fitted={'vertically'}>
                                            <CustomGrid.Column>
                                                <Form.Field
                                                  inline
                                                  className={'mfaMethodField'}
                                                  onClick={() => wrapSelectMethodHandler(isEmailConfigured, MFA_TYPE.EMAIL)}
                                                >
                                                    <Input
                                                        control='input'
                                                        type='radio'
                                                        name='method'
                                                        id='email'
                                                        checked={(methodType === MFA_TYPE.EMAIL && !isEmailConfigured)}
                                                        disabled={isEmailConfigured}
                                                        />
                                                    <MethodItem
                                                        title="Email"
                                                        type={MFA_TYPE.EMAIL}
                                                        isItConfigured={isEmailConfigured}
                                                        disabled={isEmailConfigured}
                                                        description="Receive an email message containing a verification code."
                                                    />
                                                </Form.Field>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row compact={'vertically'}>
                                            <CustomGrid.Column>
                                                <Form.Field inline className="mfaMethodFieldDisabled"  onClick={null}>
                                                    <Input
                                                        control='input'
                                                        type='radio'
                                                        name='method'
                                                        id='sms'
                                                        checked={methodType === MFA_TYPE.SMS}
                                                        disabled />
                                                        <MethodItem
                                                            title="Text message (SMS)"
                                                            disabled={true}
                                                        />
                                                </Form.Field>
                                            </CustomGrid.Column>
                                        </CustomGrid.Row>
                                    </CustomGrid>
                                </Form.Group>
                            </Form>
                        </CustomGrid.Column>
                    </CustomGrid.Row>
                </CustomGrid>
            </MFAContainer>
        </>
    )
}

export default MethodSelector;
